import { render, staticRenderFns } from "./帮助中心详情.vue?vue&type=template&id=21f3845a&scoped=true"
import script from "./帮助中心详情.vue?vue&type=script&lang=js"
export * from "./帮助中心详情.vue?vue&type=script&lang=js"
import style0 from "./帮助中心详情.vue?vue&type=style&index=0&id=21f3845a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21f3845a",
  null
  
)

export default component.exports